const laboratories = {
  convocatorias: {
    testimonios: [
      {
        title: "2026",
        slug: "2026",
      },
      {
        title: "2025",
        slug: "2025",
      },
      {
        title: "2024",
        slug: "2024",
      },
      {
        title: "2023",
        slug: "2023",
      },
      {
        title: "2022",
        slug: "2022",
      },
      {
        title: "2021",
        slug: "2021",
      },
      {
        title: "2020",
        slug: "2020",
      },
      {
        title: "2019",
        slug: "2019",
      },
      {
        title: "2018",
        slug: "2018",
      },
      {
        title: "2017",
        slug: "2017",
        practicantes: [
          {
            name: "Silke Donayre",
            photo: "../../resources/img/fotos/2017/2017_silke_donayre.webp",
            university: "Universidad Peruana de Ciencias Aplicadas - UPC",
            specialty: "Estudiante de Ing. Electrónica",
            description:
              "Mi experiencia en el programa fue muy buena porque aprendí programación, algo que quería aprender desde hace mucho. El clima laboral es bastante cálido que incluso llegue a formar amistades durante el transcurso de este tiempo. En resumen, fue una excelente experiencia de la cual estoy agradecida de poder haber participado.",
          },
          {
            name: "José Suclupe",
            photo: "../../resources/img/fotos/2017/2017_jose_suclupe.webp",
            university: "Universidad Nacional de Ingeniería - UNI",
            specialty: "Estudiante de Física",
            description:
              "Mi experiencia en el programa de prácticas fue muy gratificante, conseguí aplicar los conocimientos adquiridos en la Universidad, además de aprender nuevas tecnologías. Considero que el ROJ es uno de los pocos centros de investigación del Perú donde se realiza investigación e innovación tecnológica, y que además es conocido internacionalmente por su aporte en el campo de la Aeronomía.",
          },
          {
            name: "Luis De la Cruz",
            photo: "../../resources/img/fotos/2017/2017_luis_delacruz.webp",
            university: "Universidad Nacional de Ingeniería - UNI",
            specialty: "Estudiante de Ingeniería Electrónica",
            description:
              "El ROJ es una de las pocas instituciones donde se puede investigar poniendo en práctica los conocimientos adquiridos en la universidad, se aprende bastante gracias a que el programa nos asigna un proyecto a cargo de un asesor, también hay diversas charlas de capacitación y el ambiente de trabajo es agradable, las personas son amables y dispuestos a ayudarnos en cualquier duda.",
          },
          {
            name: "Marco Apolinario",
            photo: "../../resources/img/fotos/2017/2017_marco_apolinario.webp",
            university: "Universidad Nacional de Ingeniería - UNI",
            specialty: "Estudiante de Ingeniería Electrónica",
            description:
              "Mi experiencia en este programa fue gratificante debido a que hay muy pocos lugares en el Perú donde se pueda encontrar un ambiente estimulante como este y que además desarrolle realmente investigación, por lo que si su interés es por la investigación y desarrollo de proyectos yo creo que el ROJ es la mejor opción.",
          },
          {
            name: "José Avalos",
            photo: "../../resources/img/fotos/2017/2017_jose_avalos.webp",
            university: "Universidad de Ingeniería y Tecnología - UTEC",
            specialty: "Estudiante de Ingeniería Electrónica",
            description:
              "Calificaría mi instancia en ROJ como excelente! En poco más de dos meses, he logrado potenciar las habilidades en mi campo así como expandir mi red de contactos con personas de diferentes campos de investigación.",
          },
          {
            name: "Giancarlo Patiño",
            photo: "../../resources/img/fotos/2017/2017_giancarlo_patino.webp",
            university: "Universidad de Ingeniería y Tecnología - UTEC",
            specialty: "Estudiante de Ingeniería Electrónica",
            description:
              "Es una vivencia única, con proyectos ambiciosos que han logrado llevar nuestros conocimientos a otro nivel, fuera de la teoría de libros y aulas, permitiéndonos así desenvolvernos en el mundo real, a través del desarrollo de nuevas tecnologías en de investigar y hacer ciencia a través del desarrollo de proyectos.",
          },
          {
            name: "Harris Chaudhry",
            photo: "../../resources/img/fotos/2017/2017_harris_chaudry.webp",
            university: "Pontificia Universidad Católica del Perú - PUCP",
            specialty: "Estudiante de Ingeniería Electrónica",
            description:
              "El programa de prácticas me permitió desarrollar un proyecto afín a la carrera conjuntamente con un asesor; conocer acerca del funcionamiento interno de un Radio Observatorio y aprender temas nuevos orientados a radares, procesamiento, etc.",
          },
        ],
      },
      {
        title: "2016",
        slug: "2016",
      },
      {
        title: "2015",
        slug: "2015",
      },
      {
        title: "2014",
        slug: "2014",
      },
      {
        title: "2013",
        slug: "2013",
      },
    ],
    proyectos: [
      {
        title: "2026",
        slug: "2026",
      },
      {
        title: "2025",
        slug: "2025",
      },
      {
        title: "2024",
        slug: "2024",
      },
      {
        title: "2023",
        slug: "2023",
      },
      {
        title: "2022",
        slug: "2022",
      },
      {
        title: "2021",
        slug: "2021",
      },
      {
        title: "2020",
        slug: "2020",
      },
      {
        title: "2019",
        slug: "2019",
      },
      {
        title: "2018",
        slug: "2018",
      },
      {
        title: "2017",
        slug: "2017",
      },
      {
        title: "2016",
        slug: "2016",
      },
      {
        title: "2015",
        slug: "2015",
      },
      {
        title: "2014",
        slug: "2014",
      },
    ],
  },
};

function getLaboratories(program) {
  return laboratories[program] || laboratories["convocatorias"];
}
export { getLaboratories };
